import {
    FETCH_PRODUCTS_REQUEST, 
    FETCH_PRODUCTS_SUCCESS, 
    FETCH_PRODUCTS_FAIL, 
    SET_SELECTED_PRODUCT,
    REMOVE_SELECTED_PRODUCT} from './productConstants';

import api from '../../api/backend';

export const fetchProducts = () => async (dispatch) =>{

    try{
        dispatch({type : FETCH_PRODUCTS_REQUEST})

        const res = await api.get('/api/products/');

        dispatch({type : FETCH_PRODUCTS_SUCCESS, 
                    payload : res.data.products})

    }catch(err){
        dispatch({type : FETCH_PRODUCTS_FAIL, 
                    payload : err.response && (err.response.data.message ? 
                                                err.response.data.message : err.message)})
    }
}

export const fetchProduct = (selectedId) => async (dispatch) =>{
    // try {
        const res = await api.get(`/api/products/${selectedId}`);
        dispatch({type : SET_SELECTED_PRODUCT, payload : res.data.product})
    // }
}

export const removeSelectedProduct = () => async (dispatch) =>{
    dispatch({type : REMOVE_SELECTED_PRODUCT})
}